module.exports = __webpack_public_path__ + "img/truck02.62b040d9.png";